exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-43c77e76]{overflow-y:auto;display:inline-block;-webkit-box-sizing:border-box;box-sizing:border-box;vertical-align:top;font-size:14px;background:#f1f2f6;padding:24px;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-preferred-size:auto;flex-basis:auto}.content[data-v-43c77e76]::-webkit-scrollbar{width:6px;height:2px}.content[data-v-43c77e76]::-webkit-scrollbar-thumb{border-radius:10px;background-color:hsla(220,4%,58%,0);transition:background-color .3s;border:none}.content[data-v-43c77e76]:hover::-webkit-scrollbar-thumb{background-color:hsla(220,4%,58%,.3)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?minimize!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43c77e76","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Main/index.vue
// module id = 664
// module chunks = 0